import LogoutButton from "./LogoutButton"
import algoimg from "../images/algorand-logo.png"
import dollarimg from "../images/dollar.png"
import iaqlogoimg from "../images/IAQ-logo.PNG"
import Button from 'react-bootstrap/Button'
import axios from "axios"
import { useState, useEffect } from "react"

export default function Footer() {
  const year = (new Date()).getFullYear()
  const [iaqpriceUSD, setIaqPriceUSD] = useState("");
  const [iaqpriceALGO, setIaqPriceALGO] = useState("");

  useEffect(() => {
    getData();
  });

  async function getData() {
    const response = await axios.get("https://free-api.vestige.fi/asset/923640017/price");
    setIaqPriceUSD(response.data.USD.toFixed(3));
    setIaqPriceALGO(response.data.price.toFixed(3));
  };

  return (
    <footer id="footer" className="d-flex justify-content-between align-items-center px-5 py-3">
      <span className="text-muted">
        Copyright © {year} Element Data. All Rights Reserved
      </span>
      <div className="social">
        <a href="https://twitter.com/data_element"><i className="bi bi-twitter px-3 h4"></i></a>
        <a href="https://discord.gg/ReZxN5W9Jw"><i className="bi bi-discord px-3 h4"></i></a>
        <a href="mailto: support@elementdata.xyz"><i className="bi bi-envelope-at px-3 h4"></i></a>
      </div>
      <Button id="iaqPrice" variant="outline" href="https://app.tinyman.org/#/swap?asset_in=0&asset_out=923640017" target="_blank"><img src={iaqlogoimg} alt="" width="30" /> ( <img src={dollarimg} alt="" width="20" /> {iaqpriceUSD} <img src={algoimg} alt="" width="22" /> {iaqpriceALGO} )</Button>
      <LogoutButton />
    </footer>
  )
}
